module.exports = __webpack_public_path__ + "img/DE00653.6d82a051.png";